import { render, staticRenderFns } from "./driversSettings.vue?vue&type=template&id=66bf3fe9"
import script from "./driversSettings.vue?vue&type=script&lang=js"
export * from "./driversSettings.vue?vue&type=script&lang=js"
import style0 from "./driversSettings.vue?vue&type=style&index=0&id=66bf3fe9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports